import { MDBIcon } from "mdb-react-ui-kit";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import React, { useState } from "react";
import { toast } from 'react-toastify';
import { useCurrentUser } from "../hooks/useCurrentUser";
import { http } from '../services/httpService';
import "./PDFViewer.css"

const fileType = [ 'application/pdf' ];

export default function PDFViewer(
    {
        setPdfFile,
        filteredUser,
        onUploadSuccess,
    } ) {

    const currentUser = useCurrentUser();
    const [ selectedFile, setSelectedFile ] = useState( null );

    const handleChange = ( event ) => {
        const selectedFile = event.target.files[ 0 ];

        if ( selectedFile ) {

            if ( fileType.includes( selectedFile.type ) ) {
                let reader = new FileReader();
                reader.readAsDataURL( selectedFile );
                reader.onloadend = () => {
                    setPdfFile( reader.result );
                };
                setSelectedFile( selectedFile );
            }
        } else {
            setPdfFile( null );
            setSelectedFile( null );
        }
    };

    const handleSave = async ( e ) => {
        e.preventDefault();

        const userIdToUse = filteredUser?.id || currentUser?.id;

        if ( selectedFile && userIdToUse ) {
            const token = localStorage.getItem( 'token' );

            try {
                const formData = new FormData();
                formData.append( "file", selectedFile );
                formData.append( "userId", userIdToUse );

                const response = await http( "user/upload-pdf", {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${ token }`,
                    },
                    body: formData,
                } );

                if ( !response.ok ) {
                    throw new Error( "Erreur lors de l'enregistrement du fichier PDF." );
                }

                toast.success( "Le fichier PDF a été enregistré avec succès." );
                onUploadSuccess?.( selectedFile.name );

            } catch ( error ) {
                console.error( error );
                toast.error( "Erreur lors de l'enregistrement du fichier PDF." );
            }
        } else {
            toast.error( "Veuillez sélectionner un fichier PDF et un utilisateur." );
        }
    };

    return (
        <div className="pdf-viewer">
            <form>
                <div className='text-center mt-5'>
                    <p className='text-white'>Voulez-vous enregistrer directement un CV depuis votre ordinateur ?</p>
                </div>
                <div className="file-card col-6 justify-content-center mx-auto">
                    <div className="file-inputs">
                        <input className="upload-input" type="file" onChange={ handleChange }/>
                        <button className='upload'>
                            <MDBIcon fas icon="plus-circle me-1"/>
                            Upload
                        </button>
                    </div>
                    <p className="main fw-bold">Fichiers pris en charge :</p>
                    <p className="info">PDF</p>

                    <button className="btn" onClick={ handleSave }>
                        Confirmer
                    </button>
                </div>
            </form>
        </div>
    );
}
